export enum ECustomersColumnKey {
  User = 'user',
  Email = 'email',
  Phone = 'phone',
  Branch = 'branch_name',
  Status = 'status',
  Actions = 'actions',
  Segment = 'segment',
  Menu = 'menu',
  WalletUserGuid = 'wallet_user_guid',
  ExternalId = 'external_id',
  CustomerGuid = 'customer_guid',
}

export enum ECounterpartyStatus {
  Closed = 0,
  Active = 1,
  Blocked = 2,
}

export enum ECounterpartyAction {
  Edit = 'edit',
  Delete = 'delete',
}

export enum EQueryParams {
  Page = 'page',
  PageSize = 'pageSize',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EUserManagementCustomersPageGetParams {
  Action = 'action',
}

export enum EUserManagementCustomersPageGetParamsActionTypes {
  Create = 'create',
}

export enum ECustomersFormItemNames {
  Counterparty = 'counterparty',
  Name = 'name',
  Surname = 'surname',
  PaternalName = 'paternal_name',
  Email = 'email',
  Phone = 'phone',
  Branch = 'branch_guid',
  Segment = 'segment',
  AssetCode = 'asset_code',
  AssetIssuer = 'asset_issuer',
  IBAN = 'iban',
  Status = 'status',
  ExternalID = 'external_id',
  Login = 'login',
  Password = 'password',
}
